import AmioHttpService from '@/services/amio/amio-http.service'

class UtilsService extends AmioHttpService {
  async testApiCall({ url, httpVerb, headers, body, variables }) {
    try {
      const response = await this.requestPost('/utils/test-api-call', {
        url,
        http_verb: httpVerb,
        headers,
        body,
        variables
      })
      return adaptApiCallTestResponse(response.data)
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async previewXmlFeed(url, itemTag) {
    try {
      const params = { url }
      if (itemTag) {
        params.itemTag = itemTag
      }
      const response = await this.requestGet('/utils/preview-xml-feed', { params })
      return adapt(response.data)
    } catch (err) {
      throw this.handleError(err)
    }
  }
}

function adaptApiCallTestResponse(response) {
  return {
    httpStatus: response.http_status,
    body: response.body,
    headers: response.headers,
    message: response.message,
    error: !!response.error
  }
}

function adapt(response) {
  const adaptedResponse = {
    itemTag: response.item_tag,
    itemTagData: response.item_tag_data
  }

  return adaptedResponse
}

export default new UtilsService()
